import { candleParser } from '../candleParser';

/**
 * example:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645477363298,
	"notificationDetails": {"updateType":"SETUP_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"triggeredSetupPattern":"2u-1-2","candleDuration":1,"timeUnit":"MINUTES","candle":{"high":101.0,"low":99.0,"open":100.0,"close":100.0,"candleSymbol":"XYZ","candleStartTimeStamp":1641110640000,"duration":"1min"}},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"FLAG","symbol":"XYZ"},
	"date": "2022-02-21T16:02:43.866-0500",
	"timestamp": "1645477363868"
}


 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candleDuration
 * 2) timeUnit
 * 3) candle (object with fields: high,low,open,close,candleSymbol,duration,candleStartTimeStamp)
 * 4) triggeredSetupPattern (such as 2u-1-2)
 */
export function flagParser(pluginTemplate) {
  const parsedObject = {
    triggeredSetupPattern: null,
    candleDuration: null,
    timeUnit: null,
    candle: null,
  };
  if (pluginTemplate) {
    parsedObject.triggeredSetupPattern = pluginTemplate.triggeredSetupPattern;
    parsedObject.candleDuration = pluginTemplate.candleDuration;
    parsedObject.timeUnit = pluginTemplate.timeUnit;
    const candle = candleParser(pluginTemplate.candle);
    if (candle) {
      parsedObject.candle = candle;
    }
  }
  return parsedObject;
}
